import Work1 from "../../imgs/cat.png";
import Work2 from "../../imgs/pose.png";
import Work3 from "../../imgs/quture.png";
import Work4 from "../../imgs/social.png";

export const WorkProjectData = [
  {
    title: "Quture",
    description:
      "An AI-powered secondhand fashion platform that makes it easy to discover, define, and exchange unique pieces — all in one seamless experience. Think Depop meets Pinterest, with personalized feeds, virtual wardrobes, and a smarter way to thrift.",
    link: "https://emilyhan0212.wixsite.com/website",
    downloadLink: "https://linktr.ee/reyquture",
    image: Work3,
    tags: ["AI/ML", "Product", "Fashion"],
  },
  {
    title: "Pose",
    description:
      "A real-time photography coaching app that helps anyone look their best on camera. With live pose suggestions, shot feedback, and inspiration overlays, Pose makes every photoshoot feel like working with a creative director — all from your phone.",
    link: "https://silver-floss-e13.notion.site/Pose-Feature-Canvas-1d89a7fa99dc80c882a5e7da041d9391",
    image: Work2,
    tags: ["AI/ML", "Mobile", "Photography"],
  },
  {
    title: "Cat vs Environment",
    description:
      "A fast-paced arcade game where players control a cat dodging obstacles and collecting treasures. Features include power-ups, dynamic difficulty scaling, and various game mechanics like double jump and dash abilities.",
    link: "https://bombim21.itch.io/cat-vs-environment?secret=cKBXxlj2b7VLgyJbTYTtJ6glH4",
    image: Work1,
    tags: ["Game Development", "Unity", "C#"],
  },
  {
    title: "Social Media Creator Strategy Dashboard",
    description:
      "An analytics dashboard built with Palantir Foundry, providing creators and marketers AI-driven insights, strategic recommendations, and automated performance alerts by integrating data from YouTube, TikTok, and Shopify—all in one intuitive interface.",
    link: "https://youtu.be/VBN7Cmjt9HE",
    image: Work4,
    tags: ["Data Analytics", "AI/ML", "Social Media"],
  },
];
